import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppSettings } from '../shared/AppSettings';
import { tPatientTypeModel } from '../models/tPatientTypeModel';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class tPatientTypeService {

  private selected_pricebook_PatientTypeModel_Source = new BehaviorSubject<tPatientTypeModel>(null);
  current_selected_pricebook_PatientTypeModel = this.selected_pricebook_PatientTypeModel_Source.asObservable();

  priceBookShareSelected(model: tPatientTypeModel) {
      this.selected_pricebook_PatientTypeModel_Source.next(model);
  }



  constructor(private http: HttpClient) { }

  baseurl: string = AppSettings.BaseURI;

  readonly pathName = '/PatientType';

  getAllData(){
    return this.http.get<tPatientTypeModel[]>(this.baseurl + this.pathName);
  }

  getDataById(shopID: number,typeID: string){
    return this.http.get<tPatientTypeModel>(this.baseurl + this.pathName + '/' + shopID+ '/' + typeID);
  }

  addData(data: tPatientTypeModel){
    return this.http.post(this.baseurl + this.pathName, data);
  }

  deleteData(data: tPatientTypeModel){
    return this.http.delete(this.baseurl + this.pathName + '/' + data.shopID+ '/'+ data.pTypeID);
  }

  updateData(data: tPatientTypeModel){
    return this.http.put(this.baseurl + this.pathName + '/' + data.shopID+ '/' + data.pTypeID, data);
  }
}